import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	assignToMe: {
		id: 'issue-create-commons.assignee-field.assign-to-me',
		defaultMessage: 'Assign to me',
		description: 'Assign to me button label for assignee field',
	},
});
